import { Outlet } from 'react-router';
import Navigation from '../components/Navigation';

export default function IndexPage() {
  return (
    <>
      <Navigation />
      <Outlet />
    </>
  );
}
